import { render } from "./StatsBarChart.vue?vue&type=template&id=7491d004"
import script from "./StatsBarChart.vue?vue&type=script&lang=js"
export * from "./StatsBarChart.vue?vue&type=script&lang=js"

import exportComponent from "/Users/lolo/projects/mygpsworkouts-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__